import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Environment } from './app/commons-lib';
import { patchCnmapEditor } from './app/utils/cnmap-editor.patches';
import { StringUtils } from './app/utils/string.utils';

patchCnmapEditor();

fetch('/api/configs/config-front')
    .then((response) => (response.ok ? response : fetch('/assets/configs/config.debug.json')))
    .then((response) => response.json())
    .then((config) => {
        window['env'] = config;

        // Import dynamique de Sentry (si configuré) et AppModule après avoir défini window.env
        if (StringUtils.isNotEmpty(window.env.sentryDsn)) {
            const packageJson = require('../package.json');

            import('@sentry/angular').then((Sentry) => {
                Sentry.init({
                    dsn: window.env.sentryDsn,
                    // integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
                    release: packageJson.version as string,
                    // tracesSampleRate: 1,
                    environment: window.env.environment,
                    // replaysSessionSampleRate: 0.1,
                    // replaysOnErrorSampleRate: 1,
                    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
                    transportOptions: {
                        maxQueueSize: 100,
                    } as any,
                });
            });
        }

        // Import dynamique d'AppModule
        import('./app/app.module').then(({ AppModule }) => {
            if (Environment.production) {
                enableProdMode();
            }
            platformBrowserDynamic()
                .bootstrapModule(AppModule)
                .catch((err) => console.error(err));
        });
    });
